export default "__VITE_ASSET__B5XCLbhp__"